import React from 'react'
import { IBreadcrumb } from '../services/RouterService'
import { store } from '../store'

export function useBreadcrumbs(breadcrumbs: IBreadcrumb[]) {
  React.useEffect(() => {
    store.ui.breadcrumbs = breadcrumbs
  }, [breadcrumbs])
}
